// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('order.transitReports', {
        url: '/transitreports',
        templateUrl: 'main/order/reports/transitReports.tpl.html',
        controller: 'TransitReportsController as vm',
        resolve: {
            locations: locationsResolver
        }
    });
}

// @ngInject
function locationsResolver(OrdersApiService) {
    return OrdersApiService.getLocations();
}

// @ngInject
function TransitReportsController($translate, OrdersApiService, ToasterService, locations, loadSpinnerService) {
    var vm = this;

    //Properties
    vm.reportParameters = {
        comparisonDate: new Date(),
        locationIds: []
    };
    vm.selectedLocations = [];
    vm.selectedCompanies = [];
    vm.printLanguage = 'se';
    vm.locations = locations;
    vm.selectedLocations = angular.copy(locations);

    //Methods
    vm.getTransitReport = getTransitReport;

    function getTransitReport() {
        vm.reportParameters.locationIds = [];
        vm.selectedLocations.forEach(function(location) { vm.reportParameters.locationIds.push(location.id); });
        vm.reportParameters.languageCode = vm.printLanguage;

        loadSpinnerService.start("mainSpinner");
        OrdersApiService.downloadTransitReport(vm.reportParameters).then(function(response) {
            if (response && response.status === 204) {
                ToasterService.showWarning(
                    $translate.instant('reports.ui.transit.comparisonDate') + ' ' +
                        formatDate(vm.reportParameters.comparisonDate) + ' ' +
                    $translate.instant('common.noResults'),
                    $translate.instant('reports.ui.transit')
                );
            }
        }, function(error) {
            console.log(error);
            ToasterService.showError(error, $translate.instant('common.error'));
        }).finally(function () {
            loadSpinnerService.stop("mainSpinner");
        });
    }

    function formatDate(date) {
        if (!date) { return ''; }
        return date.getFullYear() + '-' + zeroFill(date.getMonth() + 1, 2) + '-' + zeroFill(date.getDate(), 2);
    }
    function zeroFill(number, width)
    {
        width -= number.toString().length;
        if (width > 0)
        {
            return new Array(width + ((/\./).test(number) ? 2 : 1)).join('0') + number;
        }
        return number + ''; // always return a string
    }
}

angular.module('order.transitReports', [])
    .config(stateConfig)
    .controller('TransitReportsController', TransitReportsController);
